class vehicleSelection {
  constructor() {
    this.init();
  }

  checkCurrentSelection() {
    document.querySelector('[data_selected_vehicle]').classList.remove('d-none');
    setTimeout(() => {
      let myInterval = setInterval(() => {
        if (easysearch && easysearch != undefined && easysearch != null) {
          if (easysearch.curIndex != "" && easysearch.curIndex != ",,,") {
            let selectedModalArray = easysearch.curIndex.split(',');

            // var vehicleNameElementsDesktop = document.querySelectorAll('[data-desktop-vehicle-name]');
            
            var vehicleName = `${selectedModalArray[0]} ${selectedModalArray[1]} ${selectedModalArray[2]}`;

            document.querySelector('#selectedVehicle').innerHTML = vehicleName;  
            // document.querySelector('[data_selected_vehicle]').classList.remove('d-none');
            if (vehicleName != null) {
              document.title = vehicleName + ' | Springrates.com'; 
            }
            // if (window.screen.width >= 992) {
            //   document.querySelector('.desktop-vehicle-selection[data_vehicle_selection]').classList.add('d-lg-none');
            // } else {
            //   document.querySelector('.mobile-vehicle-selection[data_vehicle_selection]').classList.add('d-none');
            // }
            // if (vehicleNameElementsDesktop.length > 0) {
            //   vehicleNameElementsDesktop.forEach((item) => {
            //     item.innerHTML = vehicleName.slice(0, 13) + '...';
            //   })
            // }
            clearInterval(myInterval);
          } 
          else {
            let vehicleName = '';
            if (document.querySelector('.collection-breadcrub-first')) {
              vehicleName = document.querySelector('.collection-breadcrub-first').textContent.replace('+', '');
            }
            if (document.querySelector('.collection-breadcrub-second')) {
              let secondText = document.querySelector('.collection-breadcrub-second').textContent;
              let secondTextArray = secondText.split('+');
              vehicleName  = secondTextArray[1] + vehicleName + secondTextArray[0];
            } else {
              document.querySelector('[data_selected_vehicle]').classList.add('ele-inactive');
              if (window.screen.width >= 992) {
                document.querySelector('.desktop-vehicle-selection[data_vehicle_selection]').classList.add('ele-active');
              } else {
                document.querySelector('.mobile-vehicle-selection[data_vehicle_selection]').classList.add('ele-active');
              }
            }

            document.querySelector('#selectedVehicle').innerHTML = vehicleName;  
            // document.querySelector('[data_selected_vehicle]').classList.remove('d-none');
            
            // if (vehicleName != null) {
            //   document.title = vehicleName + ' | Springrates.com'; 
            // }
            clearInterval(myInterval);
          }
        }
      }, 1000)
    }, 2000)
  }

  init() {
    this.checkCurrentSelection();
  }
}
new vehicleSelection();
